module.exports = __webpack_public_path__ + "img/Bodice-Back-Ja-Kd-Lb.df9f14b3.png";